import React, { Component } from 'react'
import Title from './Title'
import { FaRegCalendarCheck, FaPhone } from 'react-icons/fa'
import { MdCardGiftcard } from 'react-icons/md'
export default class Services extends Component {
    state = {
        services: [
            {
                icon: <FaRegCalendarCheck size={38} />,
                title: "reservation",
                info: "We can make a reservation on the phone for you. Save your lovely seat!"

            },
            {
                icon: <MdCardGiftcard size={45} />,
                title: "gift card",
                info: "We offer a gift card at the restaurant. Gift this card to someone who loves our restaurant!"

            },
            {
                icon: <FaPhone size={36} />,
                title: "take out",
                info: "We take a take-out order on the phone so that we can save your time!"

            }

        ]
    }
    render() {
        return (
            <section className="services">
                <Title title='services' />
                <div className="services-center">
                    {this.state.services.map((item, index) => {
                        return <article key={index} className="service">
                            <span>{item.icon}</span>
                            <h6>{item.title}</h6>
                            <p>{item.info}</p>
                        </article>
                    })}
                </div>
            </section>
        )
    }
}
